import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

// Clear console and add custom message in production
if (import.meta.env.PROD) {
  console.clear();
  console.log(
    '%c Created by Blcks: https://blcks.at',
    'background: #000; color: #fff; font-size: 12px; padding: 5px 10px; border-radius: 3px;'
  );
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
